import { render, staticRenderFns } from "./back_cover.vue?vue&type=template&id=b400f96c&"
import script from "./back_cover.vue?vue&type=script&lang=js&"
export * from "./back_cover.vue?vue&type=script&lang=js&"
import style0 from "./back_cover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports